import { storeUserData } from "@/utils/storeUserData";
import axios from "@/interceptors/axios";

export const login = async (email, password) => {
  const dataUser = { email, password };

  try {
    const response = await axios.post("/api/login", dataUser);

    const accessToken = response?.data?.auth?.access_token;
    if (accessToken) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    } else {
      throw new Error("Token de autenticação não encontrado.");
    }

    await storeUserData(response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error(
        "Erro de resposta:",
        error.response.status,
        error.response.data
      );
      throw new Error(error.response.data?.message || "Erro ao fazer login.");
    } else if (error.request) {
      console.error("Nenhuma resposta recebida:", error.request);
      throw new Error("Nenhuma resposta recebida. Verifique sua conexão.");
    } else {
      console.error("Erro:", error.message);
      throw new Error("Erro ao fazer login. Tente novamente.");
    }
  }
};

/**
 * Revoga o token do usuário no servidor e limpa a sessão local.
 * Em caso de falha na requisição, a sessão local é limpa mesmo assim.
 */
export const logout = async () => {
  try {
    await axios.post("/api/logout");
  } catch (error) {
    // Ignora erro de rede — a limpeza local deve ocorrer de qualquer forma
    console.warn("[Auth] logout remoto falhou:", error?.message);
  } finally {
    localStorage.removeItem("auth");
    localStorage.removeItem("user");
    localStorage.removeItem("permissions");
  }
};

